module.exports = __webpack_public_path__ + "img/Christa Musger.a52192ba.jpg";